export default __webpack_public_path__ + "static/media/tree2.50d58b0c.svg";